export default "__VITE_ASSET__233fe268__"